var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H40V40H16V16ZM80 16V40H56V16H80ZM56 60H64V52H56V44H64V52H72V44H80V52H72V60H80V72H72V80H64V72H52V80H44V64H56V60ZM64 60V72H72V60H64ZM16 80V56H40V80H16ZM24 24V32H32V24H24ZM64 24V32H72V24H64ZM24 64V72H32V64H24ZM16 44H24V52H16V44ZM36 44H52V60H44V52H36V44ZM44 24H52V40H44V24ZM8 8V24H0V8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0L24 0V8H8ZM88 0C90.1217 0 92.1566 0.842855 93.6569 2.34315C95.1571 3.84344 96 5.87827 96 8V24H88V8H72V0H88ZM8 72V88H24V96H8C5.87827 96 3.84344 95.1571 2.34315 93.6569C0.842855 92.1566 0 90.1217 0 88V72H8ZM88 88V72H96V88C96 90.1217 95.1571 92.1566 93.6569 93.6569C92.1566 95.1571 90.1217 96 88 96H72V88H88Z",
    fill: "#D0E2FB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.e8baf8a2.svg";
export { ForwardRef as ReactComponent };